import { v4 as uuidv4 } from "uuid";
import {
	db,
	timeStamp,
	arrayUnion,
	deleteField,
} from "../firebase/firebase.config.js";
import selectedMonth from "./selectedMonth.js";
import _ from "lodash";

const deleteExpense = (uid, id, index, date) => {
	console.log("sent data = ", uid, id, index, date);

	const uuid = uuidv4();
	const recordId = id;
	const recordIndex = index;
	const uidBanks = db.collection(uid).doc("banks");
	const uidExpenses = db.collection(uid).doc("expenses");
	const expensesHistory = uidExpenses.collection("history");
	const recordYear = new Date(date).getFullYear();
	const recordMonth = selectedMonth(new Date(date).getMonth());
	const recordDay = new Date(date).getDate();

	const deleteDay = () => {
		expensesHistory.doc(`${recordYear}`).update({
			[`${recordMonth}.${recordDay}`]: deleteField(),
		});
	};

	const deleteRecordWithId = (querySnapShotData) => {
		if (
			querySnapShotData.data()[recordMonth][recordDay][index].recordId ===
			recordId
		) {
			let DayRecords = querySnapShotData.data()[recordMonth][recordDay];
			let NewSelectedMonthTotal =
				querySnapShotData.data().monthsList[recordMonth] -
				querySnapShotData.data()[recordMonth][recordDay][index].expenseAmount;
			let NewSelectedYearTotal =
				querySnapShotData.data().total -
				querySnapShotData.data()[recordMonth][recordDay][index].expenseAmount;
			DayRecords.splice(index, 1);

			expensesHistory.doc(`${recordYear}`).update({
				total: NewSelectedYearTotal,
				[`monthsList.${recordMonth}`]: NewSelectedMonthTotal,
				[`${recordMonth}.${recordDay}`]: DayRecords,
			});
		}

		// expensesHistory.doc(`${recordYear}`).update({
		// 	[`${recordMonth}.${recordDay}`]: deleteField(),
		// });
	};

	expensesHistory
		.doc(`${recordYear}`)
		.get()
		.then((querySnapShot) => {
			if (querySnapShot.exists) {
				deleteRecordWithId(querySnapShot);
				// console.log(
				// 	querySnapShot.data()[recordMonth][recordDay][index].recordId
				// );
			}
		});
};

export default deleteExpense;
